import axios from 'axios';

console.log(process.env.NEXT_PUBLIC_API_BASE_URL)
// https://montessori.srshta.com/api
//  const baseURL = 'https://montessori.srshta.com/api';
 const baseURL = process.env.REACT_APP_APIURL;
 // const baseURL = `http://localhost:5057/api`;
// const baseURL = 'http://localhost:5057/api';
const instance = axios.create({
  baseURL:baseURL,
  timeout: 500000,
  headers: {
    Accept: 'application/json',


    'Content-Type': 'application/json',
  },
});

let isRefreshing = false;
let refreshWaitQueue = [];

const processRefreshQueue = (error, token = null) => {
  refreshWaitQueue.forEach(({ resolve, reject }) => {
    if (error) reject(error);
    else resolve(token);
  });
  refreshWaitQueue = [];
};

// Add a request interceptor
instance.interceptors.request.use(function (config) {
  // Do something before request is sent
  let token;
  if ( localStorage.getItem("id_token")) {
    token =   localStorage.getItem("id_token");
  }
  
  // If FormData, don't set Content-Type - let browser set it with boundary
  const isFormData = config.data instanceof FormData;
  
  const headers = { ...config.headers };
  if (token) {
    headers.authorization = `Bearer ${token}`;
  }
  
  // Remove Content-Type for FormData to let browser set it automatically
  if (isFormData) {
    delete headers['Content-Type'];
  }
  
  return {
    ...config,
    headers: headers,
  };
});

// On 401 (e.g. "jwt expired"): refresh the access token using the stored
// refresh token, persist the new tokens, then retry the original request.
instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const status = error.response?.status;
    const requestUrl = originalRequest?.url || '';

    if (
      status !== 401 ||
      originalRequest?._retry ||
      requestUrl.includes('/user/refresh-token') ||
      requestUrl.includes('/user/login')
    ) {
      return Promise.reject(error);
    }

    const storedRefresh = localStorage.getItem('refresh_token');
    if (!storedRefresh) {
      return Promise.reject(error);
    }

    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        refreshWaitQueue.push({ resolve, reject });
      }).then((newToken) => {
        originalRequest.headers = originalRequest.headers || {};
        originalRequest.headers.authorization = `Bearer ${newToken}`;
        return instance(originalRequest);
      });
    }

    originalRequest._retry = true;
    isRefreshing = true;

    try {
      const { data } = await axios.post(`${baseURL}/user/refresh-token`, {
        refreshToken: storedRefresh,
      });
      localStorage.setItem('id_token', data.token);
      if (data.refreshToken) {
        localStorage.setItem('refresh_token', data.refreshToken);
      }
      processRefreshQueue(null, data.token);
      originalRequest.headers = originalRequest.headers || {};
      originalRequest.headers.authorization = `Bearer ${data.token}`;
      return instance(originalRequest);
    } catch (refreshError) {
      processRefreshQueue(refreshError, null);
      localStorage.removeItem('id_token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('userDetail');
      return Promise.reject(refreshError);
    } finally {
      isRefreshing = false;
    }
  }
);

// console.log(process.env.API_BASE_URL);
const responseBody = (response) => response.data;

const requests = {
  get: (url, body) => instance.get(url, body).then(responseBody),

  post: (url, body, headers) =>
    instance.post(url, body, headers).then(responseBody),

  put: (url, body) => instance.put(url, body).then(responseBody),
  patch: (url, body) => instance.patch(url, body).then(responseBody),
  delete: (url, body) => instance.delete(url).then(responseBody),
  baseURL:() => baseURL ,
};

export default requests;
